import { Wallet } from '@coral-xyz/anchor'
import {
  Connection,
  Keypair,
  PublicKey,
  Transaction,
  VersionedTransaction
} from '@solana/web3.js'
import type { WalletContextState } from '@solana/wallet-adapter-react'
import { SOLANA_RPC_ENDPOINT } from 'app/solana-config'

export const connection = new Connection(SOLANA_RPC_ENDPOINT, {
  commitment: 'confirmed'
})

export function walletAdapterToAnchorWallet(
  wallet: WalletContextState
): Wallet {
  return {
    publicKey: wallet.publicKey as PublicKey,
    payer: Keypair.generate(),
    signTransaction: async <T extends Transaction | VersionedTransaction>(
      tx: T
    ): Promise<T> => {
      if (!wallet.signTransaction) {
        throw new Error('Wallet does not support signTransaction')
      }
      const signed = await wallet.signTransaction(tx as Transaction)
      return signed as T
    },
    signAllTransactions: async <T extends Transaction | VersionedTransaction>(
      txs: T[]
    ): Promise<T[]> => {
      if (!wallet.signAllTransactions) {
        throw new Error('Wallet does not support signAllTransactions')
      }
      const signed = await wallet.signAllTransactions(txs as Transaction[])
      return signed as T[]
    }
  }
}
